import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./BeverageLanding.module.css";
import { BtnUi } from "~/components";
import { sendPageViewWhenConsentReady } from "../../utils/adobeDataLayerUtils";

// Constants
const ANIMATION_DURATION = 300; // milliseconds for fade out animation

export const BeverageThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  useEffect(() => {
    return sendPageViewWhenConsentReady("Beverage Thank You Page", 'Passions-FavBevs', 'beverages');
  }, []);

  // Clean up sessionStorage when component unmounts
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("savedBeveragePreferences");
    };
  }, []);

  const handleDone = () => {
    // Start slide out animation
    setIsAnimatingOut(true);

    // Navigate after animation completes
    setTimeout(() => {
      // Preserve query parameters when navigating back to preferences
      navigate(`/beverage/preferences${location.search}`);
    }, ANIMATION_DURATION);
  };

  return (
    <div className={styles.landingContainer}>
      {/* Hero Section */}
      <div className={styles.heroSection}>
        <div className={styles.heroImageContainer}>
          <img
            src="https://cache.marriott.com/is/image/marriotts7prod/bonvoy-points-redemption--33160?wid=1440"
            alt="Poolside breakfast with beverages"
            className={styles.heroImage}
          />
        </div>
      </div>

      {/* Content Section */}
      <div
        className={`${styles.contentSection} ${isAnimatingOut ? styles.fadeOut : styles.fadeIn}`}
      >
        <h1 className={styles.mainHeading}>
          Thank you. Your preferences have been saved.
        </h1>

        <p className={styles.subheading}>
          Our hotel associates will do their best to deliver a perfect moment
          during your next stay with Marriott.
        </p>

        <BtnUi
          data-testid="beverage-restart"
          className={`${styles.getStartedButton} custom_click_track`}
          data-custom_click_track_value="Beverage Thank You|Tell Us About Another One|internal"
          onClick={handleDone}
        >
          Tell Us About Another One
        </BtnUi>
      </div>
    </div>
  );
};
